import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export function useExamSessions(isAdmin) {
  const [examSets, setExamSets] = useState([]);
  const [examSessions, setExamSessions] = useState([]);
  const [loadingExamSessions, setLoadingExamSessions] = useState(false);

  const fetchExamSets = async () => {
    if (!isAdmin) return;

    const { data, error } = await supabase
      .from("exam_sets")
      .select("id, exam_set_name, exam_type, use_type, total_questions, is_active")
      .eq("is_active", true)
      .in("use_type", ["class_exam", "both"])
      .order("created_at", { ascending: false });

    if (error) {
      console.error("FETCH EXAM SETS ERROR:", error);
      alert(error.message);
      return;
    }

    setExamSets(data || []);
  };

  const fetchExamSessions = async () => {
    if (!isAdmin) return;

    setLoadingExamSessions(true);

    const { data, error } = await supabase
      .from("exam_sessions")
      .select("id, exam_set_id, cohort_id, session_name, duration_minutes, session_status, start_time, end_time, created_at")
      .order("created_at", { ascending: false });

    if (error) {
      console.error("FETCH EXAM SESSIONS ERROR:", error);
      alert(error.message);
    } else {
      setExamSessions(data || []);
    }

    setLoadingExamSessions(false);
  };

  const createExamSession = async ({
    examSetId,
    cohortId,
    sessionName,
    durationMinutes,
  }) => {
    if (!examSetId || !cohortId || !sessionName || !durationMinutes) {
      alert("Please select exam set, cohort, and fill in all fields.");
      return;
    }

    const { data: { session } } = await supabase.auth.getSession();

    const { error } = await supabase.from("exam_sessions").insert({
      exam_set_id: examSetId,
      cohort_id: cohortId,
      session_name: sessionName,
      duration_minutes: Number(durationMinutes),
      session_status: "open",
      start_time: new Date().toISOString(),
      opened_by: session?.user?.id,
    });

    if (error) {
      alert(error.message);
      return;
    }

    alert("Exam session opened successfully.");

    await fetchExamSessions();
  };

  useEffect(() => {
    if (isAdmin) {
      fetchExamSets();
      fetchExamSessions();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  return {
    examSets,
    examSessions,
    loadingExamSessions,
    fetchExamSets,
    fetchExamSessions,
    createExamSession,
  };
}